import { JSX } from "preact";

export function StatBar(props: { children: JSX.Element }) {
  return <div class="stat-bar">{props.children}</div>;
}

export function Stat(props: { value: string; label: string }) {
  return (
    <div class="stat">
      <div class="stat-value">{props.value}</div>
      <div class="stat-label">{props.label}</div>
    </div>
  );
}